import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { PenguinIllustration } from "@/components/PenguinState";

export default function NotFound() {
  const nvg = useNavigate();
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-10 text-center" data-testid="not-found-page">
      <PenguinIllustration variant="not-found" size="page" testid="penguin-not-found" />
      <h1 className="font-display mt-6 text-3xl font-bold text-[#0B132B] sm:text-4xl">Not Found</h1>
      <p className="mt-2 max-w-md text-sm text-slate-500">We couldn't find the page you're looking for. It may have moved or no longer exists.</p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <button onClick={() => nvg(-1)} data-testid="notfound-back" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-2.5 text-sm font-semibold text-[#0B132B] hover:bg-slate-50">
          <ArrowLeft size={16} /> Go Back
        </button>
        <Link to="/dashboard" data-testid="notfound-home" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#14B8A6] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#0B132B]">
          <Home size={16} /> Go Home
        </Link>
      </div>
    </div>
  );
}
